import * as z from "zod";
import type { TFunction } from "i18next";

import { requiredApiDecimalString } from "@/shared/utils";

const DATE_STRING_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const requiredDateString = (
  t: TFunction,
  requiredKey: string,
  invalidKey: string,
) =>
  z
    .string()
    .trim()
    .min(1, t(requiredKey))
    .refine((value) => DATE_STRING_PATTERN.test(value), t(invalidKey));

/** PRD admin-structures.md §4.5 — sub-modal Novo/Editar manejo. */
export const createAdminStructureReservoirManagementSchema = (t: TFunction) =>
  z.object({
    occupiedArea: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.occupiedAreaRequired",
      "admin.structures.reservoirManagement.validation.occupiedAreaInvalid",
    ),
    totalVolume: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.totalVolumeRequired",
      "admin.structures.reservoirManagement.validation.totalVolumeInvalid",
    ),
    totalOccupiedVolume: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.totalOccupiedVolumeRequired",
      "admin.structures.reservoirManagement.validation.totalOccupiedVolumeInvalid",
    ),
    availableVolume: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.availableVolumeRequired",
      "admin.structures.reservoirManagement.validation.availableVolumeInvalid",
    ),
    rejectOccupiedVolume: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.rejectOccupiedVolumeRequired",
      "admin.structures.reservoirManagement.validation.rejectOccupiedVolumeInvalid",
    ),
    waterOccupiedVolume: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.waterOccupiedVolumeRequired",
      "admin.structures.reservoirManagement.validation.waterOccupiedVolumeInvalid",
    ),
    waterLevel: requiredApiDecimalString(
      t,
      "admin.structures.reservoirManagement.validation.waterLevelRequired",
      "admin.structures.reservoirManagement.validation.waterLevelInvalid",
    ),
    recordedOn: requiredDateString(
      t,
      "admin.structures.reservoirManagement.validation.recordedOnRequired",
      "admin.structures.reservoirManagement.validation.recordedOnInvalid",
    ),
  });

export type AdminStructureReservoirManagementForm = z.infer<
  ReturnType<typeof createAdminStructureReservoirManagementSchema>
>;
